<template>
  <el-dialog
    append-to-body
    width="400px"
    title="扣款来源"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
  >
    <div class="resource-class">{{ info}}</div>
  </el-dialog>
</template>
<script>
export default {
  name: "handleRefundDialog",
  data() {
    return {
      visible: false,
      btnLoading: false,
      info: null,
    };
  },
  methods: {
    getDetail(row) {
      this.$http
        .get("/admin/invoice/show", { params: { id: row.id } })
        .then((res) => {
          let list = res.data.list.map(item =>item.nickname);
          this.info = list.join(",");
        });
    },
    reset(done) {
      this.info = null;
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style scoped lang="scss">
.resource-class {
  text-align: center;
  margin-bottom: 10px;
}
</style>